<template>
  <wui-modal
    :size="40"
  >
    <template #header>
      <h2
        data-test="confirm-dialog-with-icon-title"
        class="wui-modal__title text-heading-sb-16-22 text-fg-base-fg3 max-w-[313px]"
      >
        {{ title }}
      </h2>
    </template>

    <p
      data-test="confirm-dialog-with-icon-description"
      class="text-body-r-14-20 text-fg-base-fg10 max-w-[313px]"
    >
      {{ description }}
    </p>

    <template #footer>
      <wui-btn
        variant="neut"
        state="alpha"
        :size="40"
        @click="close"
      >
        {{ $t('common.cancel') }}
      </wui-btn>
      <wui-btn
        :size="40"
        variant="negative"
        state="alpha"
        :disabled="isLoading!"
        auto-loading
        @click="emit('yes')"
      >
        <wui-icon
          v-if="isLoading"
          name="spinner"
          small
        />
        <span v-else>{{ acceptBtnText }}</span>
      </wui-btn>
    </template>
  </wui-modal>
</template>

<script lang="ts" setup>
import { closeDialogKey, IconName, safeInject, WuiBtn, WuiIcon, WuiModal } from '@wui/common-library'

const closeModal = safeInject(closeDialogKey)

const emit = defineEmits<{
  (e: 'yes'): void
  (e: 'no'): void
}>()

defineProps<{
  title: string
  description: string
  icon: IconName
  acceptBtnText: string
  isLoading?: boolean
}>()

const close = () => {
  emit('no')
  closeModal(false)
}
</script>
